import Carousel from "../../../../../components/Carousel";
import CardArticle from "../../../../Dashboard/Posts/components/CardArticle";
import Grid from '../../../../../components/Grid'
import Icon from '../../../../../components/Icon'
import { medals } from "../../../../../constants/medals";
import { connect, useDispatch } from "react-redux";
import CategoryListHeader from "./components/CategoryListHeader"
import ViewMoreButton from "./components/ViewMoreButton"
import {
  Card,
  Flex,
  CloseButton
} from './styles'
import { useWindowSize } from "../../../../../hooks/useWindowSize";
import { CategoryDto } from "../../../../../types/category";
import { Group } from "../../../../../types";
import { useEffect, useMemo } from "react";
import { getAllCategories } from "../../../../../store/actions/category";
import closeCircled from '../../../../../assets/icons/close_circled.svg'
import EmptyList from './components/EmptyList'
import { showPreference } from "../../../../../helpers/preferenceVisible";
import { savePreference } from "../../../../../store/actions/preferences";
import ViewAllCategoriesButton from "./components/ViewAllCategoriesButton";

interface ComponentProps {
  group: Group
  allCategories: CategoryDto[]
  preferences,
  preferencesStates,
}

const Component = ({
  group,
  allCategories,
  preferences,
  preferencesStates,
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const dispatch = useDispatch()

  const unlockedCategories = useMemo(() => {
    return allCategories
      ?.filter(item => item?.is_unlockable && item?.locked_ordinal !== undefined)
      ?.filter(item => item?.last_posts && item?.last_posts?.length > 0)
      ?.filter(item => item?.user_access_data?.is_unlocked)
      ?.filter(item => {
        const show = showPreference({
          preferences,
          preferencesStates,
          id: `unlocked-category-${item?.id}`,
        })

        return show
      })
      ?.sort((a, b) => (b.locked_ordinal ?? Infinity) - (a.locked_ordinal ?? Infinity))
  }, [allCategories, preferences, preferencesStates]);

  const onClose = (idCategory) => {
    dispatch(
      savePreference({
        preferenceSlug: `unlocked-category-${idCategory}`,
        preferenceValue: false,
      })
    );
  }

  const category = useMemo(() => {
    if (unlockedCategories && unlockedCategories?.length > 0) {
      return unlockedCategories[0]
    }
  }, [unlockedCategories])

  useEffect(() => {
    dispatch(getAllCategories({
      group_id: group?.id,
      with_posts: true,
      only_showable_posts: false,
      enrich_unlockable_data_for_user: true
    }));
  }, [])

  if (!unlockedCategories || (unlockedCategories && unlockedCategories?.length <= 0) || preferencesStates.loading || !category) {
    return <div style={{ height: 26 }} />
  }

  return (
    <>
      {/* {unlockedCategories[unlockedCategories?.length - 1]?.map((category: CategoryDto) => ( */}
      <Card
        key={`unlocked-category-list-${category?.id}`}
        {...(
          category?.locked_ordinal &&
            medals[category.locked_ordinal - 1]
            ? { background: medals[category.locked_ordinal - 1].background_horizontal }
            : { background: "#dfdddd" }
        )}
      >
        <Grid.Container {...(isMobile && { gutter: 0 })}>
          <Grid.Row {...(isMobile && { gutter: 0 })}>
            <Grid.Col lg={10} offset={{ lg: 1 }} {...(isMobile && { gutter: 0 })}>
              {onClose && (
                <CloseButton onClick={() => onClose(category?.id)}>
                  <Icon icon={closeCircled} size="24px" color="black" />
                </CloseButton>
              )}

              <CategoryListHeader category={category} />

              <div style={{ height: 26 }} />

              {category?.last_posts && category?.last_posts.length > 0 ?
                <Carousel
                  items={category?.last_posts}
                  renderItem={(post, index) => (
                    <CardArticle
                      key={`unlocked-category-${category.id}-post-${post.id}`}
                      post={post}
                      groupInformation={group}
                      showPinAction={false}
                    />
                  )}
                  slidesToShow={3}
                  scrollAmount={250}
                  animationSpeed={400}
                  showArrows={category?.last_posts?.length >= 4}
                  style={isMobile ? {
                    padding: "0px 20px 10px",
                    scrollSnapType: "x mandatory",
                    scrollPadding: "0px 20px"
                  } : {}}
                />
                :
                <EmptyList />
              }

              <div style={{ height: 32 }} />

              <Flex style={{ flexDirection: isMobile ? 'column' : 'row', gap: 16 }}>
                <ViewMoreButton onClick={() => onClose(category?.id)} category={category} />
                <ViewAllCategoriesButton onClick={() => onClose(category?.id)} category={category} />
              </Flex>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      </Card>
      {/* ))} */}

      <div style={{ height: 26 }} />
    </>
  )
};

const state = ({ categoryStore, groupStore, preferencesStore }) => {
  const { data: allCategories } = categoryStore.allCategories;
  const { data: group } = groupStore.group;
  const { data: preferences, states: preferencesStates } = preferencesStore.preferences;
  return {
    group,
    allCategories,
    preferences,
    preferencesStates
  };
};

export default connect(state)(Component);
